/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import { useRouter } from 'next/router'
import DateCard from './date-sty'
import TimeCard from './time-sty'
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import index from '../footer/footer-3'
import CircularProgress from '@mui/material/CircularProgress'
import { useDispatch, useSelector } from '../../redux/store'
import { checkTime, checkTimeForPricing } from '../../redux/slices/activity'
import { Box, Divider } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'

const SidebarRight = ({ activityData }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { _id, city, checkIn, checkOut } = router.query
  const { checkTimeRes, checkTimeResForPricing } = useSelector(
    state => state.activity
  )
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [currentTime, setCurrentTime] = useState(null)
  const [timeSlot, setTimeSlot] = useState([])
  const [openCalendar, setOpenCalendar] = useState(false)
  const [adult, setAdult] = useState(1)
  const [child, setChild] = useState(0)
  const [senior, setSenior] = useState(0)
  const [group, setGroup] = useState(1)
  const [maxGroupReached, setMaxGroupReached] = useState(false)
  const [alert, setAlert] = useState({})
  const [groupOriginalPrice, setGroupOriginalPrice] = useState(0)
  const [adultOriginalPrice, setAdultOriginalPrice] = useState(1)
  const [childOriginalPrice, setChildOriginalPrice] = useState(0)
  const [seniorOriginalPrice, setSeniorOriginalPrice] = useState(0)
  const [choice, setChoice] = useState([])
  const [choiceData, setChoiceData] = useState(null)
  const [message, setMessage] = useState('')
  const [newDate, setNewDate] = useState(moment().format('YYYY-MM-DD'))
  const [startNewDate, setStartNewDate] = useState(moment().format('YYYY-MM-DD'));
  const [currentIndex, setCurrentIndex] = useState(null)
  const [choiceLoader, setChoiceLoader] = useState(false)
  const today = moment(new Date()).format('YYYY-MM-DD')

  useEffect(() => {
    if (router && activityData?.startDate) {
      if (checkIn && checkIn !== null && checkIn !== '') {
        setCurrentDate(moment(checkIn).format('YYYY-MM-DD'))
        setNewDate(moment(checkIn).format('YYYY-MM-DD'))
        setStartNewDate(moment(checkIn).format('YYYY-MM-DD'))
      } else {
        if (
          moment(new Date()).isSameOrAfter(
            moment(activityData?.startDate).format('YYYY-MM-DD')
          )
        ) {
          setCurrentDate(moment(new Date()).format('YYYY-MM-DD'))
          setNewDate(moment(new Date()).format('YYYY-MM-DD'))
          setStartNewDate(moment(new Date()).format('YYYY-MM-DD'))
        } else {
          setCurrentDate(moment(activityData?.startDate).format('YYYY-MM-DD'))
          setNewDate(moment(activityData?.startDate).format('YYYY-MM-DD'))
          setStartNewDate(moment(activityData?.startDate).format('YYYY-MM-DD'))
        }
        setEndDate(moment(activityData?.endDate).format('YYYY-MM-DD'))
      }
    }
  }, [router, activityData])

  useEffect(() => {
    if (activityData || choiceData) {
      const personWithMatchingName = choiceData?.timeSlots?.find(
        person => person.day === moment(currentDate).format('dddd')
      )

      if (checkTimeRes?.status === 1 && checkTimeRes?.slot) {
        setTimeSlot(checkTimeRes?.slot)
      } else {
        setTimeSlot([])
      }

      setTimeSlot(prevSlot =>
        Array.isArray(prevSlot) &&
          JSON.stringify(prevSlot) !== JSON.stringify(checkTimeRes?.slot)
          ? checkTimeRes?.slot
          : prevSlot
      )

      setChoice(prevChoice =>
        prevChoice !== activityData?.choice ? activityData?.choice : prevChoice
      )

      setChoiceData(prevChoiceData => {
        const updatedChoiceData = {
          ...prevChoiceData,
          optionType: checkTimeRes?.optionType,
          groupOptions: checkTimeRes?.groupOption,
          personOptions: checkTimeRes?.personOption
        }

        return JSON.stringify(prevChoiceData) !==
          JSON.stringify(updatedChoiceData)
          ? updatedChoiceData
          : prevChoiceData
      })
    }
  }, [activityData, currentDate, checkTimeRes])

  useEffect(() => {
    if (checkTimeResForPricing?.status === 1 && choiceData) {
      setChoiceData(prevChoiceData => ({
        ...prevChoiceData,
        optionType: checkTimeResForPricing.optionType,
        groupOptions: checkTimeResForPricing.groupOption,
        personOptions: checkTimeResForPricing.personOption
      }))
      setChoiceLoader(false)
    } else {
      setChoiceLoader(false)
    }
  }, [checkTimeResForPricing])

  useEffect(() => {
    if (choice && choice.length === 1) {
      setChoiceData(choice[0])
    } else {
      setChoiceData(null)
    }
  }, [choice])

  useEffect(() => {
    if (timeSlot && timeSlot.length !== 0) {
      setCurrentTime(timeSlot[0])
    }
  }, [timeSlot])

  const handleChangeDate = date => {
    const selectedDay = moment(date).format('dddd') // Get the selected day
    setCurrentDate(moment(date).format('YYYY-MM-DD')) // Set the current date

    if (choiceData?.timeSlotType === 2) {
      const personWithMatchingName = choiceData?.timeSlots?.find(
        person => person.day === selectedDay
      )

      if (personWithMatchingName?.slots.length === 0) {
        return
      }
    }
  }

  const handleChangeCalenderDate = date => {
    var count = 0;
    [1, 2, 3, 4].map((item, index) => {
      if (
        moment(newDate).add(index, 'days').format('YYYY-MM-DD') ===
        moment(date).format('YYYY-MM-DD')
      ) {
        count = count + 1
      }
    })

    if (count === 0) {
      setNewDate(moment(date).format('YYYY-MM-DD'))
    }
    setCurrentDate(moment(date).format('YYYY-MM-DD'))

    setOpenCalendar(false)
  }

  const handleChangeTime = date => {
    setCurrentTime(date)
  }

  const handleChangeCalendar = () => {
    setOpenCalendar(!openCalendar)
  }

  const currentTim = new Date()

  const handleChangeChoice = data => {
    setChoiceData(data)
  }

  useEffect(() => {
    const obj = {
      activityId: activityData?._id,
      packageId: choiceData?._id,
      currentTime: moment(currentTim).format('HH:mm'),
      day: moment(currentDate).format('dddd'),
      date: currentDate
    }

    dispatch(checkTime(obj))
  }, [dispatch, choiceData?._id, currentDate])

  useEffect(() => {
    const obj = {
      activityId: activityData?._id,
      packageId: choiceData?._id,
      currentTime: moment(currentTim).format('HH:mm'),
      day: moment(currentDate).format('dddd'),
      date: currentDate,
      userSelectedTime: currentTime
    }

    if (currentTime !== null) {
      dispatch(checkTimeForPricing(obj))
      setChoiceLoader(true)
    }
  }, [dispatch, choiceData?._id, currentDate, currentTime])

  const handleChangeSelection = () => {
    setChoiceData(null)
    setAdult(1)
    setChild(0)
    setSenior(0)
    setGroup(1)
    setAdultOriginalPrice(0)
    setChildOriginalPrice(0)
    setSeniorOriginalPrice(0)
    setGroupOriginalPrice(0)
  }

  useEffect(() => {
    setMessage('')
  }, [adult, child])

  const handleChangeNextPage = (e, index) => {
    if (adult === 0 && child === 0) {
      setMessage('Select at least one ticket')
    } else {
      setCurrentIndex(index)
      localStorage.setItem(
        'shortDescription',
        choiceData?.shortDescription || ''
      )
      router.push({
        pathname: `/activities/booking-page`,
        query: {
          // country: countryValue,
          _id: _id,
          choiceId: choiceData._id,
          city: city,
          checkIn: checkIn,
          checkOut: checkOut,
          adult: adult,
          child: child,
          senior: senior,
          packageName: activityData?.name,
          choiceName: choiceData?.name,
          image: activityData?.image,
          date: currentDate,
          time: currentTime,
          adultAmt: choiceData?.personOptions?.adultPrice || 0,
          childAmt: choiceData?.personOptions?.childPrice || 0,
          seniorAmt: choiceData?.personOptions?.seniorPrice || 0,
          optionType: choiceData?.optionType,
          group: choiceData?.optionType === 1 ? group : 0,
          groupAmt: choiceData?.groupOptions?.price,
          groupOriginalAmt: choiceData?.groupOptions?.groupOriginalPrice,
          adultOriginalPrice: adultOriginalPrice,
          childOriginalPrice: childOriginalPrice,
          seniorOriginalPrice: seniorOriginalPrice,
          groupOriginalPrice: groupOriginalPrice,
          adultOriginalAmt: choiceData?.personOptions?.adultOriginalPrice,
          childOriginalAmt: choiceData?.personOptions?.childOriginalPrice,
          seniorOriginalAmt: choiceData?.personOptions?.seniorOriginalPrice,
          vendorId: activityData?.vendorInfo?._id,
          currency: activityData?.currency,
          vat: activityData?.vat,
          extraCharge: activityData?.extraCharge,
          withPickup: activityData?.withPickup,
          termAndCondition: activityData?.termAndCondition,
          // pickupPoint: JSON.stringify(activityData?.pickupPoint)
          // room: guetsValue.Rooms
          // time: moment(bookPickUpDate).format("YYYY-MM-DD hh:mm:ss A"),
        }
      })
    }
  }

  const renderDateCards = (handleChangeCalendar) => {
    return [1, 2, 3, 4, 5].map((item, index) => {
      const date = moment(newDate).add(index, 'days')
      const dayName = date.format('dddd')
      const personWithMatchingName = choiceData?.timeSlots?.find(
        person => person.day === dayName
      )

      const personWithMatching = choiceData?.pricingOption
        ?.map(pricingOption => pricingOption.timeSlots)
        .find(timeSlots => timeSlots.some(slot => slot.day === dayName))

      if (
        // choiceData?.timeSlotType !== 2 ||
        personWithMatchingName?.slots.length > 0 ||
        personWithMatching || choiceData?.timeSlotType === 3
      ) {
        return (
          index === 4 ? ( // ✅ 4th Index (Change Calendar Button)
            <li className='col-12 py-10' key={index}>
              <button
                className='btn date-btn'
                style={{
                  padding: '6px 12px',
                  height: '100%',
                  width: "100%",
                  display: "flex",
                  justifyContent: 'center',
                  alignItems: "center",
                  gap: "10px"
                }}
                onClick={() => handleChangeCalendar()}
              >
                <EventAvailableIcon />
                <p className='color-light-blue text-13'>More Dates</p>

                {/* FontAwesome Calendar Icon */}
              </button>
            </li>
          ) : (
            <li className='col-3 py-10' key={index}>
              <DateCard
                handleChangeDate={handleChangeDate}
                currentDate={currentDate}
                date={date.format()}
              />
            </li>
          )
        )
      } else {
        return (
          index === 4 && <li className='col-12 py-10' key={index}>
            <button
              className='btn date-btn'
              style={{
                padding: '6px 12px',
                height: '100%',
                width: "100%",
                display: "flex",
                justifyContent: 'center',
                alignItems: "center",
                gap: "10px"
              }}
              onClick={() => handleChangeCalendar()}
            >
              <EventAvailableIcon />
              <p className='color-light-blue text-13'>More Dates</p>

              {/* FontAwesome Calendar Icon */}
            </button>
          </li>
        )
      }

      return null
    })
  }

  const handleIncrement = () => {
    if (group < choiceData?.packageBookingLimitPerDay) {
      setGroup(group + 1)
      setGroupOriginalPrice(groupOriginalPrice + 1)
      setAlert(prev => ({ ...prev, group: '' }))
      setMaxGroupReached(false)
    } else {
      setMaxGroupReached(true)
      setAlert(prev => ({
        ...prev,
        group: `Maximum ${choiceData?.packageBookingLimitPerDay} Slot Available`
      }))
    }
  }

  const handleDecrement = () => {
    if (group > 1) {
      setGroup(group - 1)
      setGroupOriginalPrice(groupOriginalPrice - 1)
      setAlert(prev => ({ ...prev, group: '' }))
      setMaxGroupReached(false)
    } else {
      setAlert(prev => ({ ...prev, group: 'Group min count is 1!' }))
    }
  }

  const isActivityAvailable = (
    activityData,
    choiceData,
    timeSlot,
    checkTimeRes
  ) => {
    if (activityData?.status !== 1) {
      return false // Activity is unavailable
    }

    const isTimeSlotValid =
      choiceData?.timeSlotType !== 3 ? !timeSlot || timeSlot.length !== 0 : true

    if (!isTimeSlotValid || checkTimeRes?.isAvailable === false) {
      return false // Fully booked
    }

    return true // Activity is available
  }

  return (
    <Box
      className='lg:ml-0 mx-20 rounded'
      sx={{
        border: '1px solid #0000001f',
        padding: '15px'
      }}
    >
      <div>
        <h4 className='font-weight-bold'>Available Packages</h4>
        {/* <h6 className='pt-20 pb-20'>When would you like to go?</h6> */}
      </div>

      {choiceData?._id ? (
        <section className='container-fluid px-0'>
          <div className='f-size-14' style={{ color: 'red' }}>
            {message}
          </div>
          <div className='col-md-3 w-100'>
            <table className='w-100'>
              <tr className='mt-10 align-start'>
                <td colSpan='1' className='wd-50'>
                  <h6>{choiceData?.name}</h6>
                </td>
                {choice && choice?.length > 1 && (
                  <td className='wd-50 justify-end'>
                    <button
                      className='btn more-sty'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                      onClick={handleChangeSelection}
                    >
                      Change Package
                    </button>
                  </td>
                )}
              </tr>
              {choiceData?.shortDescription && (
                <tr className='mt-10 align-start'>
                  <div className='longDescription text-light-1'>
                    {choiceData?.shortDescription}
                  </div>
                </tr>
              )}
            </table>
            <Divider
              className='my-3'
              sx={{
                borderColor: 'grey !important'
              }}
            />

            {/* <table>
              <tr>
                <td colSpan="1" className="wd-50">
                  <p>{choiceData?.shortDescription}</p>
                </td>
              </tr>
            </table> */}

            {choiceData?.highlights.map((demo, index) => (
              <div className='d-flex gap-10 align-center' key={index}>
                <div>
                  <i
                    className='icon-check text-10 mr-20'
                    style={{ color: 'green' }}
                  />
                </div>
                <div>
                  <p className='f-size-14 fw-600 c-green'>{demo.name}</p>
                </div>
              </div>
            ))}
            <div className='d-flex gap-10 align-center'>
              <h6 className='f-size-14'>How many tickets?</h6>
            </div>
            <section className='container-fluid pl-0 pr-0' id='activity-calander'>
              <p>Search ticket availability by date</p>
              {/* {!openCalendar ? (
                <button className='btn more-sty' onClick={handleChangeCalendar}>
                  Show more dates
                </button>
              ) : (
                <button
                  className='btn more-sty pb-20'
                  onClick={handleChangeCalendar}
                >
                  Close Calendar
                </button>
              )} */}

              {!openCalendar ? (
                <div className='container'>
                  <ul className='row date-sty'>
                    {renderDateCards(handleChangeCalendar)}
                  </ul>
                </div>
              ) : (
                <Calendar
                  minDate={new Date(startNewDate)}
                  maxDate={new Date(endDate)}
                  onChange={handleChangeCalenderDate}
                  className="my-3"
                  value={new Date(currentDate)}
                  tileDisabled={({ date }) => {
                    const dayName = moment(date).format('dddd')
                    const personWithMatchingName = choiceData?.timeSlots?.find(
                      person => person.day === dayName
                    )
                    return (
                      choiceData?.timeSlotType === 2 &&
                      personWithMatchingName?.slots.length === 0
                    )
                  }}
                />
              )}
            </section>
            {timeSlot && timeSlot.length !== 0 ? (
              <section className='container-fluid pt-30 pl-0'>
                <h6>Select time</h6>
                <div className='container pt-20'>
                  <ul className='row date-sty'>
                    {timeSlot.map((item, index) => (
                      <li className='col-4 py-10 time-sty' key={index}>
                        <TimeCard
                          handleChangeTime={handleChangeTime}
                          currentTime={currentTime}
                          value={item}
                          date={moment(newDate).add(index, 'days').format()}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
            ) : (
              ''
            )}
            <Divider
              className='my-3'
              sx={{
                borderColor: 'grey !important'
              }}
            />

            {choiceLoader ? (
              <div className='d-flex gap-10 align-center'>
                <table className='w-100'>
                  {[...Array(1)].map((_, index) => (
                    <div key={index}>
                      <Skeleton
                        variant='rectangular'
                        width='100%'
                        height='100px'
                        animation='pulse'
                      />
                    </div>
                  ))}
                </table>
              </div>
            ) : (
              <div className='d-flex gap-10 align-center'>
                <table className='w-100'>
                  {isActivityAvailable(
                    activityData,
                    choiceData,
                    timeSlot,
                    checkTimeRes
                  ) && (
                      <div>
                        {choiceData?.optionType === 2 ? (
                          <>
                            {choiceData.personOptions?.adultPrice !== null &&
                              choiceData.personOptions?.adultPrice !== '' ? (
                              <>
                                <tr className='js-spbt mt-10'>
                                  <td colSpan='1'>
                                    <div>
                                      <div className='f-size-12'>
                                        Adult (age 12+)
                                      </div>
                                      <h5 className='f-size-14'>

                                        {activityData?.currency.toUpperCase()}{' '}
                                        {choiceData?.personOptions?.adultPrice}{' '}
                                        {Number(
                                          choiceData?.personOptions
                                            ?.adultOriginalPrice
                                        ) >
                                          Number(
                                            choiceData?.personOptions?.adultPrice
                                          ) && (
                                            <>
                                              <span
                                                style={{
                                                  color: 'grey',
                                                  fontSize: '12px',
                                                  fontWeight: 'lighter',
                                                  textDecoration: 'line-through'
                                                }}
                                              >
                                                {activityData?.currency.toUpperCase()}{' '}
                                                {
                                                  choiceData?.personOptions
                                                    ?.adultOriginalPrice
                                                }
                                              </span>
                                              <br />
                                            </>
                                          )}
                                      </h5>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='ft-size ft-wet fixed-size-container'>
                                      <div className='col-auto fixed-size-container'>
                                        <div
                                          className={`d-flex items-center js-counter ${alert?.adult ? 'b-rsl-error' : 'b-rsl'
                                            }`}
                                        >
                                          <button
                                            className={`button ${alert?.adult
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-down`}
                                            onClick={() => {
                                              if (adult > 1) {
                                                setAdult(
                                                  adult !== 0 ? adult - 1 : 1
                                                )
                                                setAdultOriginalPrice(
                                                  adultOriginalPrice !== 0
                                                    ? adultOriginalPrice - 1
                                                    : 0
                                                )
                                                setAlert(prev => ({
                                                  ...prev,
                                                  adult: ''
                                                }))
                                                setMaxGroupReached(false)
                                              }
                                            }}
                                          >
                                            <i className='icon-minus text-12' />
                                          </button>
                                          {/* decrement button */}
                                          <div className='flex-center size-20 ml-15 mr-15'>
                                            <div
                                              className={`${alert?.adult ? 'text-red' : ''
                                                } text-15 js-count`}
                                            >
                                              {adult}
                                            </div>
                                          </div>
                                          {/* counter text  */}
                                          <button
                                            className={`button ${alert?.adult
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-up`}
                                            onClick={() => {
                                              if (
                                                adult <
                                                choiceData?.personOptions
                                                  ?.adultCount
                                              ) {
                                                setAdult(adult + 1),
                                                  setAdult(adult + 1),
                                                  setAlert(prev => ({
                                                    ...prev,
                                                    adult: ''
                                                  }))
                                                setMaxGroupReached(false)
                                              } else {
                                                setMaxGroupReached(true)
                                                setAlert(prev => ({
                                                  ...prev,
                                                  adult: `Maximum ${choiceData?.personOptions?.adultCount} Adults Allowed!`
                                                }))
                                              }
                                            }}
                                          >
                                            <i className='icon-plus text-12' />
                                          </button>
                                          {/* increment button */}
                                        </div>
                                        {alert?.adult && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '10px',
                                              lineHeight: '1.2',
                                              marginTop: '2px'
                                            }}
                                            className='fw-light text-center'
                                          >
                                            {alert?.adult}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              ''
                            )}

                            {choiceData.personOptions?.childPrice !== null &&
                              choiceData.personOptions?.childPrice !== '' &&
                              choiceData.personOptions?.childPrice > 0 ? (
                              <>
                                <tr className='js-spbt mt-10'>
                                  <td colSpan='1'>
                                    <div>
                                      <div className='f-size-12'>{`Child (age ${choiceData?.personOptions?.childAge
                                        ? choiceData?.personOptions?.childAge
                                        : '1-5'
                                        })`}</div>
                                      <h5 className='f-size-14'>

                                        {activityData?.currency.toUpperCase()}{' '}
                                        {choiceData?.personOptions?.childPrice}{' '}
                                        {Number(
                                          choiceData?.personOptions
                                            ?.childOriginalPrice
                                        ) >
                                          Number(
                                            choiceData?.personOptions?.childPrice
                                          ) && (
                                            <>
                                              <span
                                                style={{
                                                  color: 'grey',
                                                  fontSize: '12px',
                                                  fontWeight: 'lighter',
                                                  textDecoration: 'line-through'
                                                }}
                                              >
                                                {activityData?.currency.toUpperCase()}{' '}
                                                {
                                                  choiceData?.personOptions
                                                    ?.childOriginalPrice
                                                }
                                              </span>
                                              <br />
                                            </>
                                          )}
                                      </h5>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='ft-size ft-wet fixed-size-container'>
                                      <div className='col-auto fixed-size-container'>
                                        <div
                                          className={`d-flex items-center js-counter ${alert?.child ? 'b-rsl-error' : 'b-rsl'
                                            }`}
                                        >
                                          <button
                                            className={`button ${alert?.child
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-down`}
                                            onClick={() => {
                                              if (child > 0) {
                                                setChild(
                                                  child !== 0 ? child - 1 : 0
                                                )
                                                setChildOriginalPrice(
                                                  childOriginalPrice !== 0
                                                    ? childOriginalPrice - 1
                                                    : 0
                                                )
                                                setAlert(prev => ({
                                                  ...prev,
                                                  child: ''
                                                }))
                                                setMaxGroupReached(false)
                                              }
                                            }}
                                          >
                                            <i className='icon-minus text-12' />
                                          </button>
                                          {/* decrement button */}
                                          <div className='flex-center size-20 ml-15 mr-15'>
                                            <div
                                              className={`${alert?.child ? 'text-red' : ''
                                                } text-15 js-count`}
                                            >
                                              {child}
                                            </div>
                                          </div>
                                          {/* counter text  */}
                                          <button
                                            className={`button ${alert?.child
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-up`}
                                            onClick={() => {
                                              if (
                                                child <
                                                choiceData?.personOptions
                                                  ?.childCount
                                              ) {
                                                setChild(child + 1),
                                                  setChildOriginalPrice(
                                                    childOriginalPrice + 1
                                                  )
                                                setAlert(prev => ({
                                                  ...prev,
                                                  child: ''
                                                }))
                                                setMaxGroupReached(false)
                                              } else {
                                                setMaxGroupReached(true)
                                                setAlert(prev => ({
                                                  ...prev,
                                                  child: `Maximum ${choiceData?.personOptions?.childCount} Child Allowed!`
                                                }))
                                              }
                                            }}
                                          >
                                            <i className='icon-plus text-12' />
                                          </button>
                                          {/* increment button */}
                                        </div>
                                        {alert?.child && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '10px',
                                              lineHeight: '1.2',
                                              marginTop: '2px'
                                            }}
                                            className='fw-light text-center'
                                          >
                                            {alert?.child}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ) : null}

                            {choiceData.personOptions?.seniorPrice !== null &&
                              choiceData.personOptions?.seniorPrice !== '' &&
                              choiceData.personOptions?.seniorPrice > 0 ? (
                              <>
                                <tr className='js-spbt mt-10'>
                                  <td colSpan='1'>
                                    <div>
                                      <div className='f-size-12'>
                                        Senior (age 55–99)
                                      </div>
                                      <h5 className='f-size-14'>

                                        {activityData?.currency.toUpperCase()}{' '}
                                        {choiceData.personOptions?.seniorPrice}{' '}
                                        {Number(
                                          choiceData?.personOptions
                                            ?.seniorOriginalPrice
                                        ) >
                                          Number(
                                            choiceData?.personOptions?.seniorPrice
                                          ) && (
                                            <>
                                              <span
                                                style={{
                                                  color: 'grey',
                                                  fontSize: '12px',
                                                  fontWeight: 'lighter',
                                                  textDecoration: 'line-through'
                                                }}
                                              >
                                                {activityData?.currency.toUpperCase()}{' '}
                                                {
                                                  choiceData?.personOptions
                                                    ?.seniorOriginalPrice
                                                }
                                              </span>
                                              <br />
                                            </>
                                          )}
                                      </h5>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='ft-size ft-wet fixed-size-container'>
                                      <div className='col-auto fixed-size-container'>
                                        <div
                                          className={`d-flex items-center js-counter ${alert?.senior
                                            ? 'b-rsl-error'
                                            : 'b-rsl'
                                            }`}
                                        >
                                          <button
                                            className={`button ${alert?.senior
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-down`}
                                            onClick={() => {
                                              if (senior > 0) {
                                                setSenior(
                                                  senior !== 0 ? senior - 1 : 0
                                                )
                                                setSeniorOriginalPrice(
                                                  seniorOriginalPrice !== 0
                                                    ? seniorOriginalPrice - 1
                                                    : 0
                                                )
                                                setAlert(prev => ({
                                                  ...prev,
                                                  senior: ''
                                                }))
                                                setMaxGroupReached(false)
                                              }
                                            }}
                                          >
                                            <i className='icon-minus text-12' />
                                          </button>
                                          {/* decrement button */}
                                          <div className='flex-center size-20 ml-15 mr-15'>
                                            <div
                                              className={`${alert?.senior ? 'text-red' : ''
                                                } text-15 js-count`}
                                            >
                                              {senior}
                                            </div>
                                          </div>
                                          {/* counter text  */}
                                          <button
                                            className={`button ${alert?.senior
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-up`}
                                            onClick={() => {
                                              if (
                                                senior <
                                                choiceData?.personOptions
                                                  ?.seniorCount
                                              ) {
                                                setSenior(senior + 1),
                                                  setSeniorOriginalPrice(
                                                    seniorOriginalPrice + 1
                                                  )
                                                setAlert(prev => ({
                                                  ...prev,
                                                  senior: ''
                                                }))
                                                setMaxGroupReached(false)
                                              } else {
                                                setMaxGroupReached(true)
                                                setAlert(prev => ({
                                                  ...prev,
                                                  senior: `Maximum ${choiceData?.personOptions?.seniorCount} Senior Allowed!`
                                                }))
                                              }
                                            }}
                                          >
                                            <i className='icon-plus text-12' />
                                          </button>
                                          {/* increment button */}
                                        </div>
                                        {alert?.senior && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '10px',
                                              lineHeight: '1.2',
                                              marginTop: '2px'
                                            }}
                                            className='fw-light text-center'
                                          >
                                            {alert?.senior}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ) : null}
                          </>
                        ) : (
                          <>
                            {choiceData.groupOptions?.price !== null &&
                              choiceData.groupOptions?.price !== '' ? (
                              <>
                                <tr className='js-spbt mt-10'>
                                  <td colSpan='1'>
                                    <div>
                                      <div className='f-size-12'>
                                        Group (
                                        {
                                          choiceData?.groupOptions
                                            ?.groupMemberCount
                                        }{' '}
                                        Members)
                                      </div>
                                      <h5 className='f-size-14'>

                                        {activityData?.currency.toUpperCase()}{' '}
                                        {choiceData?.groupOptions?.price}{' '}
                                        {Number(
                                          choiceData?.groupOptions?.originalPrice
                                        ) >
                                          Number(
                                            choiceData?.groupOptions?.price
                                          ) && (
                                            <>
                                              <span
                                                style={{
                                                  color: 'grey',
                                                  fontSize: '12px',
                                                  fontWeight: 'lighter',
                                                  textDecoration: 'line-through'
                                                }}
                                              >
                                                {activityData?.currency.toUpperCase()}{' '}
                                                {
                                                  choiceData?.groupOptions
                                                    ?.originalPrice
                                                }
                                              </span>
                                              <br />
                                            </>
                                          )}

                                      </h5>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='ft-size ft-wet fixed-size-container'>
                                      <div>
                                        <div
                                          className={`d-flex items-center js-counter ${alert?.group ? 'b-rsl-error' : 'b-rsl'
                                            }`}
                                        >
                                          <button
                                            className={`button ${alert?.group
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-down`}
                                            onClick={handleDecrement}
                                          >
                                            <i className='icon-minus text-12' />
                                          </button>
                                          {/* decrement button */}
                                          <div className='flex-center size-20 ml-15 mr-15'>
                                            <div
                                              className={`${alert?.group ? 'text-red' : ''
                                                } text-15 js-count`}
                                            >
                                              {group}
                                            </div>
                                          </div>
                                          {/* counter text  */}
                                          <button
                                            className={`button ${alert?.group
                                              ? 'text-red'
                                              : 'text-dark-3'
                                              } size-38 rounded-4 js-up`}
                                            onClick={handleIncrement}
                                          >
                                            <i className='icon-plus text-12' />
                                          </button>
                                          {/* increment button */}
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          height: '20px',
                                          marginTop: '10px'
                                        }}
                                      >
                                        {alert?.group && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '10px',
                                              lineHeight: '1.2',
                                              marginTop: '2px'
                                            }}
                                            className='fw-light text-center'
                                          >
                                            {alert?.group}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              ''
                            )}
                          </>
                        )}
                      </div>
                    )}

                  {isActivityAvailable(
                    activityData,
                    choiceData,
                    timeSlot,
                    checkTimeRes
                  ) ? (
                    <tr className='js-spbt mt-10 align-end'>
                      <td colSpan='1'>
                        {activityData?.status === 1 ? (
                          <div>
                            <div className='f-size-14'>Total</div>
                            <h5 className='f-size-14'>
                              {choiceData?.optionType === 2 ? (
                                <>
                                  {activityData?.currency.toUpperCase()}{' '}
                                  {adult *
                                    (choiceData?.personOptions?.adultPrice ||
                                      0) +
                                    (child
                                      ? child *
                                      (choiceData?.personOptions
                                        ?.childPrice || 0)
                                      : 0) +
                                    (senior
                                      ? senior *
                                      (choiceData?.personOptions
                                        ?.seniorPrice || 0)
                                      : 0)}{' '}
                                </>
                              ) : (
                                <>
                                  {activityData?.currency.toUpperCase()}{' '}
                                  {group *
                                    (choiceData?.groupOptions?.price || 0)}{' '}
                                  / Group
                                </>
                              )}
                            </h5>
                          </div>
                        ) : (
                          ''
                        )}
                      </td>
                      <td>
                        <div>
                          <p
                            style={{
                              color:
                                activityData?.status !== 1
                                  ? 'red' // Show red if activity is unavailable
                                  : (choiceData?.timeSlotType !== 3
                                    ? !timeSlot || timeSlot.length !== 0
                                    : true) &&
                                    checkTimeRes?.isAvailable !== false
                                    ? ''
                                    : 'red'
                            }}
                          >
                            {activityData?.status !== 1
                              ? 'This activity is currently unavailable. Please try again later.'
                              : (choiceData?.timeSlotType !== 3
                                ? !timeSlot || timeSlot.length !== 0
                                : true) && checkTimeRes?.isAvailable !== false
                                ? ''
                                : 'Fully Booked'}
                          </p>
                        </div>
                        {!choiceData ||
                          ((choiceData?.timeSlotType !== 3
                            ? !timeSlot || timeSlot.length !== 0
                            : true) &&
                            checkTimeRes?.isAvailable !== false) ? (
                          <button
                            className='btn btn-checkout wd-100'
                            onClick={e => handleChangeNextPage(e, index)}
                          >
                            {currentIndex !== null ? (
                              <CircularProgress
                                style={{
                                  width: '20px',
                                  height: '20px'
                                }}
                              />
                            ) : (
                              'Next'
                            )}
                          </button>
                        ) : (
                          ''
                        )}
                      </td>
                    </tr>
                  ) : (
                    <div
                      style={{
                        padding: '16px',
                        textAlign: 'center',
                        color: '#666',
                        fontSize: '14px',
                        backgroundColor: '#F8F9FA',
                        borderRadius: '8px'
                      }}
                    >
                      {' '}
                      <strong style={{ fontSize: '16px', color: '#333' }}>
                        No activities available for the selected date!
                      </strong>
                      <p style={{ marginTop: '5px', color: '#697488' }}>
                        Don&apos;t miss out! Try selecting a different date to
                        explore more exciting activities.
                      </p>
                    </div>
                  )}
                </table>
              </div>
            )}
          </div>
        </section>
      ) : (
        choice &&
        choice.map((item, index) => (
          <section className='' key={index}>
            <div className='col-md-3 package-card border'>
              <h6 className='pb-10'>{item?.name}</h6>

              {item?.shortDescription && (
                <div className='shortDescription text-light-1'>
                  {item?.shortDescription}
                </div>
              )}

              <div className='d-flex gap-10 align-center pt-8'>
                <table className='w-100'>
                  <tr className='js-spbt align-end'>
                    <td colSpan='1'>
                      <div>
                        <div className='f-size-14'>From</div>
                        <h5 className='f-size-14'>
                          {activityData?.currency &&
                            activityData?.currency !== ''
                            ? activityData?.currency.toUpperCase()
                            : activityData?.currency}{' '}
                          {item?.optionType == 2 ? (
                            <>
                              {item?.adultPrice
                                ? item?.adultPrice
                                : item?.adultPrice}
                            </>
                          ) : (
                            <>
                              {item?.groupOptions
                                ? item?.groupOptions?.price
                                : item?.groupOptions?.price}
                            </>
                          )}
                        </h5>
                      </div>
                    </td>
                    <td>
                      <button
                        className='btn btn-checkout wd-100'
                        onClick={() => handleChangeChoice(item)}
                      >
                        {currentIndex !== null ? (
                          <CircularProgress
                            style={{
                              width: '20px', // Set the desired width
                              height: '20px' // Set the desired height
                            }}
                          />
                        ) : (
                          'Select'
                        )}
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </section>
        ))
      )}
    </Box>
  )
}

export default SidebarRight
